import React from 'react';
import Grid from '@mui/material/Grid';

const Research = () => {
  return (
    <Grid item xs={8}>
        <div>Research</div>
    </Grid>
  )
}

export default Research